export * from './platform-confirm-dialog.module';
export * from './platform-confirm-dialog/platfrom-confirm-dialog.component';